import React, { useState } from 'react';
import { Table, Button, Form, Row, Col, Card } from 'react-bootstrap';
import { FaPlus, FaSave, FaTimes, FaTrash, FaPen } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import * as api from '~/Services/Service';

const OPCOES_TIPO_FATOR = [
  { value: 'F', label: 'Fixo' },
  { value: 'P', label: 'Percentual' },
];

const OPCOES_BASE_CALCULO = [
  { value: '0', label: 'V.V.' },
  { value: '1', label: 'V.V. - Corrigido pelo contrato p/ data 1a correcao' },
  { value: '2', label: 'V Prazo - Negocio de Contrato' },
  { value: '3', label: 'V Prazo - Corrigido pelo Contrato p/ data 1a correcao' },
  { value: '4', label: 'V Pago - Soma Totais parcelas pagas' },
  { value: '5', label: 'V Pago - Corrigido pelo Contrato p/ data 1a correcao' },
];

const findOpt = (opts, val) => {
  if (val == null || val === '') return null;
  const s = String(val);
  return opts.find((o) => o.value === s) || null;
};

const labelBaseCalculo = (val) => {
  const opt = findOpt(OPCOES_BASE_CALCULO, val);
  return opt != null ? opt.label : val;
};

const GridRetencao = ({ codigoFamilia, retencoes, onRecarregar }) => {
  const [showForm, setShowForm] = useState(false);
  const [descricao, setDescricao] = useState('');
  const [tipoFator, setTipoFator] = useState('P');
  const [fator, setFator] = useState('');
  const [tipoBaseCalculo, setTipoBaseCalculo] = useState('0');
  const [somenteComissao, setSomenteComissao] = useState(false);
  const [somenteVendaNova, setSomenteVendaNova] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [editandoSeq, setEditandoSeq] = useState(null);

  const handleAbrirForm = () => {
    setDescricao('');
    setTipoFator('P');
    setFator('');
    setTipoBaseCalculo('0');
    setSomenteComissao(false);
    setSomenteVendaNova(false);
    setEditandoSeq(null);
    setShowForm(true);
  };

  const handleEditar = (item) => {
    setDescricao(item.descricao || '');
    setTipoFator(item.tipo_fator || 'P');
    setFator(item.fator != null ? String(item.fator) : '');
    setTipoBaseCalculo(item.tipo_base_calculo != null ? String(item.tipo_base_calculo) : '0');
    setSomenteComissao(item.somente_comissao === 'S');
    setSomenteVendaNova(item.somente_venda_nova === 'S');
    setEditandoSeq(item.sequencia);
    setShowForm(true);
  };

  const handleIncluir = async () => {
    if (!descricao.trim()) {
      toast.warn('Informe a descrição da retenção');
      return;
    }
    setSalvando(true);
    try {
      if (editandoSeq != null) {
        await api.excluirRetencaoConfig({
          codigo_familia: codigoFamilia,
          sequencia: editandoSeq,
        });
      }
      await api.incluirRetencaoConfig({
        codigo_familia: codigoFamilia,
        descricao: descricao.trim(),
        tipo_fator: tipoFator,
        fator: fator !== '' ? Number(fator) : 0,
        tipo_base_calculo: tipoBaseCalculo,
        somente_comissao: somenteComissao ? 'S' : 'N',
        somente_venda_nova: somenteVendaNova ? 'S' : 'N',
      });
      toast.success(editandoSeq != null ? 'Retenção alterada com sucesso!' : 'Retenção incluída com sucesso!');
      setShowForm(false);
      setEditandoSeq(null);
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao salvar retenção';
      toast.error(msg);
    } finally {
      setSalvando(false);
    }
  };

  const handleExcluir = async (item) => {
    if (!window.confirm(`Excluir retenção "${item.descricao}" (seq ${item.sequencia})?`)) return;
    try {
      await api.excluirRetencaoConfig({
        codigo_familia: codigoFamilia,
        sequencia: item.sequencia,
      });
      toast.success('Retenção excluída!');
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao excluir retenção';
      toast.error(msg);
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center py-2">
        <strong>Retenções</strong>
        <Button size="sm" variant="outline-primary" onClick={handleAbrirForm}>
          <FaPlus className="mr-1" /> Incluir
        </Button>
      </Card.Header>
      <Card.Body className="p-0">
        {showForm && (
          <div className="p-3 border-bottom bg-light">
            <Row>
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="small mb-1">Descrição</Form.Label>
                  <Form.Control
                    size="sm"
                    maxLength={30}
                    value={descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Tipo Fator</Form.Label>
                  <Select
                    options={OPCOES_TIPO_FATOR}
                    value={findOpt(OPCOES_TIPO_FATOR, tipoFator)}
                    onChange={(opt) => setTipoFator(opt != null ? opt.value : 'P')}
                    styles={customStyles}
                    components={{ DropdownIndicator }}
                    menuPortalTarget={document.body}
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="small mb-1">Fator</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    step="0.01"
                    value={fator}
                    onChange={(e) => setFator(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="small mb-1">Base Cálculo</Form.Label>
                  <Select
                    options={OPCOES_BASE_CALCULO}
                    value={findOpt(OPCOES_BASE_CALCULO, tipoBaseCalculo)}
                    onChange={(opt) => setTipoBaseCalculo(opt != null ? opt.value : '0')}
                    styles={customStyles}
                    components={{ DropdownIndicator }}
                    menuPortalTarget={document.body}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chk-somente-comissao"
                  label="Somente Comissão por dentro"
                  checked={somenteComissao}
                  onChange={(e) => setSomenteComissao(e.target.checked)}
                />
              </Col>
              <Col md={3}>
                <Form.Check
                  type="checkbox"
                  id="chk-somente-venda-nova"
                  label="Somente Venda Nova"
                  checked={somenteVendaNova}
                  onChange={(e) => setSomenteVendaNova(e.target.checked)}
                />
              </Col>
            </Row>
            <div className="mt-2">
              <Button
                size="sm"
                variant="success"
                className="mr-2"
                onClick={handleIncluir}
                disabled={salvando}
              >
                <FaSave className="mr-1" /> Salvar
              </Button>
              <Button
                size="sm"
                variant="secondary"
                onClick={() => setShowForm(false)}
                disabled={salvando}
              >
                <FaTimes className="mr-1" /> Cancelar
              </Button>
            </div>
          </div>
        )}
        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
        <Table striped bordered hover size="sm" className="mb-0">
          <thead>
            <tr>
              <th>Descrição</th>
              <th>Tipo Fator</th>
              <th>Fator</th>
              <th>Base Cálculo</th>
              <th>SC</th>
              <th>SVN</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {retencoes.length === 0 && (
              <tr>
                <td colSpan={7} className="text-center text-muted">
                  Nenhuma retenção cadastrada
                </td>
              </tr>
            )}
            {retencoes.map((item) => (
              <tr key={item.sequencia}>
                <td>{item.descricao}</td>
                <td>{item.tipo_fator === 'F' ? 'Fixo' : item.tipo_fator === 'P' ? 'Percentual' : item.tipo_fator}</td>
                <td>{item.fator}</td>
                <td>{labelBaseCalculo(item.tipo_base_calculo)}</td>
                <td>{item.somente_comissao === 'S' ? 'Sim' : 'Não'}</td>
                <td>{item.somente_venda_nova === 'S' ? 'Sim' : 'Não'}</td>
                <td>
                  <Button
                    size="sm"
                    variant="outline-primary"
                    title="Editar"
                    className="mr-1"
                    onClick={() => handleEditar(item)}
                  >
                    <FaPen />
                  </Button>
                  <Button
                    size="sm"
                    variant="outline-danger"
                    title="Excluir"
                    onClick={() => handleExcluir(item)}
                  >
                    <FaTrash />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default GridRetencao;
